import React, { useState, useEffect, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { IoIosArrowForward } from "react-icons/io";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Bread from "../../common/Bread";
import Loader from "../../common/Loader";
import { LangContext } from "../../context/LangContext";

const Fixed = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [isActive, setIsActive] = useState(slug);

  const { state } = useContext(LangContext);
  const isNepali = state?.np;

  useEffect(() => {
    setIsActive(slug);
  }, [slug]);
  const breadcrumList = {
    image: "",
    title: isNepali ? "फिक्स्ड डिपोजिट" : "Fixed Deposit",
    l1: isNepali ? "गृहपृष्ठ" : "Home",
    l2: isNepali ? "हाम्रा सेवाहरू" : "Products",
    l3: "",
  };
  const capFirstLetterInSentence = (sentence) => {
    if (!sentence) return "";
    return sentence
      .toLowerCase()
      .split(" ")
      .map((word) => word[0]?.toUpperCase() + word.slice(1))
      .join(" ");
  };

  const { isLoading, error, data, isFetching } = useQuery({
    queryKey: ["productsData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/product/all`)
        .then((res) => res.data),
  });

  if (isLoading || isFetching) return <Loader />;
  if (error) return <div className="error-message">Error: {error.message}</div>;

  // Get localized items
  const localizedItems = isNepali ? data.items.np : data.items.en;

  // Filter only Fixed Deposit category
  const fixedProducts = localizedItems.filter(
    (item) => item.cat_name?.toLowerCase() === "fixed"
  );

  return (
    <Bread data={breadcrumList}>
      <div className="servicePageContainer">
        {/* Content Section */}
        <div className="contentContainer">
          {fixedProducts.map((item, index) => (
            <div
              key={index}
              className="content"
              style={{ display: isActive === item.slug ? "block" : "none" }}
            >
              <h2 className="content-title">
                {capFirstLetterInSentence(item.title)}
              </h2>
              <div
                className="services-ck-content"
                dangerouslySetInnerHTML={{
                  __html: item.Description || "No content available.",
                }}
              ></div>
            </div>
          ))}
        </div>

        {/* Buttons Section */}
        <div className="buttons">
          <h2>{isNepali ? "फिक्स्ड डिपोजिट" : "Products"}</h2>
          {fixedProducts.map((item) => (
            <div
              key={item.slug}
              onClick={() => {
                navigate(`/product/fixed-deposit/${item.slug}`);
                window.scrollTo(0, 0);
              }}
              className="btn"
              style={{
                color: isActive === item.slug ? "#fff" : "#0f2137",
                backgroundColor: isActive === item.slug ? "#003399" : "#fff",
              }}
            >
              <p
                dangerouslySetInnerHTML={{
                  __html: item?.title,
                }}
              ></p>
              <IoIosArrowForward className="icon" />
            </div>
          ))}
        </div>
      </div>
    </Bread>
  );
};

export default Fixed;
